export default {
    storeName: 'seating_map_orm',
};
